/** Build query params for GET /api/gate-passes (server pagination + filters). */
export function buildGatePassListParams(page, pageSize, columnFilters = {}, sorting = null) {
  const params = { page, page_size: pageSize };

  if (sorting?.id) {
    params.ordering = `${sorting.desc ? "-" : ""}${sorting.id}`;
  } else {
    params.ordering = "-id";
  }

  const textFields = ["code", "vehicle_number", "driver_name", "party_name", "expected_variety"];
  for (const field of textFields) {
    const v = columnFilters[field];
    if (v) params[field] = v;
  }

  if (columnFilters.purpose) params.purpose = columnFilters.purpose;
  if (columnFilters.status) params.status = columnFilters.status;

  const exitVal = columnFilters.exit_request_status;
  if (exitVal === "__NONE__") params.exit_request_status = "none";
  else if (exitVal) params.exit_request_status = exitVal;

  return params;
}

export const DEFAULT_GATE_PASS_PAGE_SIZE = 25;
export const GATE_PASS_PAGE_SIZE_OPTIONS = [10, 25];
